import React from "react"
import SchemaRecordsList from "@/components/SchemaRecordsList"

export default function SchemaRecordsListView() {
  return <SchemaRecordsList />
}
